import * as React from "react";
import { Button, Typography, Box, Snackbar } from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import DialogTitle from "@mui/material/DialogTitle";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import { useTranslation } from "react-i18next";
export default function AddSikiModal(props) {
  const { t } = useTranslation("common");
  const [amount, setAmount] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [currency, setCurrecy] = React.useState("siki");

  const getFundingLink = async () => {
    if (amount >= 30 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.FUNDINGLINK(
          {
            amount: parseInt(amount),
            tag: "time to buy some BTC",
            currency: currency,
          },
          props.token ? props.token : null
        );
        setLoading(false);
        props.handleClose(response["result"]);
        console.log(response);
      } catch (error) {
        setLoading(false);

        console.log(error);
      }
    }
  };

  const handleChange = (event) => {
    setCurrecy(event.target.value);
  };

  React.useEffect(() => {
    return () => {
      console.log("cleaned up");
    };
  }, []);
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={() => props.handleClose()}
        PaperProps={{
          sx: {
            minHeight: 200,
            // backgroundColor: "#1E1E1E",
            // backgroundColor: "#171515",
            background: "#171515",
          },
        }}
      >
        <DialogTitle>{t("addSikiModal.amount")}</DialogTitle>
        <DialogContent sx={{ paddingTop: ".5rem !important" }}>
          <Box sx={{ position: "relative" }}>
            <input
              value={amount}
              type="number"
              onChange={(e) => setAmount(e.target.value)}
              style={{
                height: "25px",
                borderRadius: "25px",
                border: "0",
                padding: "5px 10px",
                backgroundColor: "#1E1E1E",
                minWidth: "200px",
                color: "#ffffff",
              }}
              placeholder="Min. 30$"
            />
            <Typography
              style={{
                position: "absolute",
                bottom: "7px",
                right: "7px",
                color: "gray",
                fontSize: "12px",
              }}
              variant="body2"
            >
              USD
            </Typography>
          </Box>
          {amount && amount < 30 ? (
            <Typography
              variant="body2"
              sx={{ fontSize: "12px" }}
              mt={1}
              color="error"
            >
              {t("addSikiModal.text1")}
            </Typography>
          ) : null}
          {amount && amount > 20000 ? (
            <Typography
              variant="body2"
              sx={{ fontSize: "12px" }}
              mt={1}
              color="error"
            >
              {t("addSikiModal.text3")}
            </Typography>
          ) : null}
          <Stack spacing={1}>
            <Typography className="fs-14">{t("addSikiModal.text2")}</Typography>

            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              aria-labelledby="currency type"
              name="select token type"
              value={currency}
              onChange={handleChange}
            >
              <FormControlLabel
                value="siki"
                control={<Radio />}
                label="SIKI Token"
              />
              <FormControlLabel value="hbar" control={<Radio />} label="HBar" />
            </RadioGroup>
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 24px 20px",
          }}
        >
          <Button
            sx={{ borderRadius: "25px", height: "36px !important" }}
            color="default"
            onClick={() => props.handleClose(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            sx={{ borderRadius: "25px", height: "36px !important" }}
            variant="contained"
            color="primary"
            onClick={() => getFundingLink()}
          >
            {t("continue")}
          </Button>
        </DialogActions>
      </Dialog>
      {loading ? <Loader /> : null}
    </div>
  );
}
